var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',{ref:"inputRef",attrs:{"dense":"","outlined":"","type":"text","value":_vm.formattedValue,"label":_vm.label,"filled":_vm.filled,"disabled":_vm.disabled,"rules":_vm.rules,"append-icon":_vm.appendIcon}})}
var staticRenderFns = []

export { render, staticRenderFns }